import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'

interface Props {
  serialNumber: number
  onSuccess: () => void
  children?: () => ReactElement
}

const DeleteAiLicenseRequest = ({
  serialNumber,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/licenses/${serialNumber}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteAiLicenseRequest
